import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { CalcAltDoseAmountMedicines } from 'src/requests/Shared'

export const useCalcAltCost = (dataItem: any, hospitalId: number | null) => {

    const [data, setData] = useState<any>(0)
    const [loading, setLoading] = useState(false)

    const { state } = useLocation()

    useEffect(() => {
        const timeout = setTimeout(() => {
            const reqData = {
                "dosePerDay": dataItem?.doseAmount,
                "doseCountPerTime": dataItem?.doseRepeat,
                "doseTypeId": dataItem?.userDoseRepeate?.value,
                "decisionId": dataItem?.decisionId,
                "durationType": dataItem?.durationType?.value,
                "duration": dataItem?.duration,
                "medicineId": dataItem?.altMedicine?.value,
                "allowsAllDurations": dataItem?.allowAllDuration,
                "directAmount": Number(dataItem?.directAmount || 0),
            }
            if (!reqData.medicineId || !reqData.durationType) return

            CalcAltDoseAmountMedicines(reqData, hospitalId, state?.pharmName?.value).then((res) => {
                setData(res.data.data)
                setLoading(false)
            }).catch(() => setLoading(false))
        }, 500);
        return () => clearTimeout(timeout);

    }, [dataItem?.doseAmount, dataItem?.doseRepeat, dataItem?.directAmount, dataItem?.userDoseRepeate, dataItem?.decisionId, dataItem?.durationType, dataItem?.duration, dataItem?.altMedicine, dataItem?.allowAllDuration])

    return { data, loading }
}
